import { Component, OnInit } from '@angular/core';
import { ProjectFileAuditorComponent } from '../../project-file-auditor/project-file-auditor.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { switchMap } from 'rxjs';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ToastrService } from 'ngx-toastr';
import { DirectionService } from '../services/direction.service';
import { TooltipModule } from 'primeng/tooltip';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { SocketService } from '../services/socket.service';
import { NotificationService } from '../services/notification.service';
import { NotificationTypesEnum } from '../interfaces';
import { IndicatorsService } from '../services/indicators.service';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../webviewer/webviewer.component';

@Component({
  selector: 'app-project-file-audit-container',
  standalone: true,
  imports: [
    DialogModule,
    WebViewerComponent,
    ProjectFileAuditorComponent,
    TooltipModule,
    ButtonModule,
    TagModule,
    TableModule,
    TranslateModule,
    RadioButtonModule,
    FormsModule,
    RouterModule
  ],
  templateUrl: './project-file-audit-single.component.html',
  styleUrl: './project-file-audit-single.component.scss'
})
export class ProjectFileAuditSingleComponent implements OnInit {
  strategyId = 0;
  projectId = 0;
  fileId = 0;
  assessmentModal = false;
  selectedFile: any;
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  searchText = ''
  milestone = {} as any;
  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private socketService: SocketService,
    private notificationService: NotificationService,
    private indicatorService: IndicatorsService

  ) {
  }
  ngOnInit(): void {
    this.route.queryParams.pipe(switchMap(({ strategyId, parentEntityId, subEntityId }) => {
      this.strategyId = strategyId
      this.projectId = parentEntityId
      this.fileId = subEntityId
      return this.projectService.listSingleMilestoneFiles(strategyId, parentEntityId, subEntityId);
    })).subscribe((x: any) => {
      this.milestone = x['data']['milestone'] as any;

    })

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;

      this.locale = dir == "rtl" ? "ar" : "en";
    })

  }

  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };

  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };

  openAssessmentModal(file: any) {
    this.assessmentModal = true;
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }
  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }

  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }
  assessOutput() {

    console.log(this.selectedFile);
    this.projectService.reviewAuditFile(this.strategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      this.milestone.files = this.milestone.files.map((x: any) => {
        if (x.id == this.selectedFile.id) {
          return { ...this.selectedFile }
        } else {
          return x;
        }
      })
      this.toastr.success(response['data']['message'])
      this.socketService.connect();
      this.notificationService.pushAuditRequest(
        this.strategyId, {
        id: this.selectedFile.id,
        parentEntityId: this.projectId,
        subEntityId: this.selectedFile.subEntityId,
        type: NotificationTypesEnum.milestone_output_audit_response
      },
        this.locale
      )
    })
  };
  isFileViewer = false;

  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
  downloadFile(file: any) {
    console.log("selected file", this.selectedFile);
    this.indicatorService.downloadOutcomeProof(this.strategyId, file.indicator_id, file.outcome_id, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }

}
